import React from 'react';
import Container from '../../Container';
import image from './campus@large.jpg';
import hkqaa from './hkqaa.svg';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default ({ locale }) => (
  <div className={styles.root}>
    <div className={styles.imageWrapper}>
      <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />
    </div>
    <Container className={styles.container}>
      <div className={styles.text}>
        <div className={styles.cert}>
          <img src={hkqaa} alt="HKQAA" />
          <div className={styles.cc}>CC1928</div>
        </div>

        {locale === 'en' ? (
          <h2 className={styles.title}>ISO 9001 Certified</h2>
        ) : (
          <h2 className={styles.title}>國際標準化組織ISO 9001認證</h2>
        )}
        {locale === 'en' ? (
          <p>
            ISO management standards are a series of frameworks that help Kingston to effectively implement our
            programme with a system of checks and balances from a third party that helps the school to comply with
            management systems of the highest standard.
          </p>
        ) : (
          <p>ISO管理標準是一套完善的管理系統，定期審核學校嚴格遵守既定的管理程序，促進京斯敦有效推行校內課程。</p>
        )}
      </div>
    </Container>
  </div>
);
